<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="品名训练"></pageTitle>

    <basicList
      :config="basicListconfig"
      @search="searchEvent"
      @sortChange="sortChange"
    >
      <template v-slot:otherOperations>
        <el-upload
          ref="upload"
          class="upload-excel"
          :action="uploadAction"
          name="file"
          :data="canshu"
          :headers="headers"
          :on-success="handleSuccess"
          :before-upload="beforeUpload"
          :file-list="fileList"
          :show-file-list="false"
          :on-change="handleChange"
          ><el-button type="primary" size="small">导入</el-button>
        </el-upload>

        <el-button
          style="margin-left: 10px"
          type="primary"
          size="small"
          @click="exportExcel"
          >导出</el-button
        >
      </template>
      <template v-slot:operation="row">
        <div>
          <template>
            <div class="button button_modify" @click="edit(row.row)">
              <i class="iconfont icon-bianji"></i> 编辑
            </div>
            <div class="button button_modify" @click="clear(row.row)">
              <i class="iconfont icon-quxiao"></i> 清空
            </div>
          </template>
        </div>
      </template>
    </basicList>
    <el-dialog
      title="编辑"
      :visible.sync="defaultParametersVisible"
      custom-class="addProductPopUpWindow"
      :close-on-click-modal="false"
      width="450px"
      append-to-body
    >
      <el-form ref="addform" :model="addform" label-position="top">
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="编码" prop="item_id">
              <el-input v-model="addform.item_number" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="品名" prop="name">
              <el-input v-model="addform.name" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="别名" prop="alias">
              <el-input
                v-model="addform.alias"
                type="textarea"
                :rows="5"
                placeholder="请输入别名，使用逗号分隔
例如：名士，马爹利名士"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button type="info" @click="close">取消</el-button>
        <el-button type="success" @click="submit">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { getSession } from "@/utils/cookie";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";
import { itemClassGetList } from "@/api/basicConfiguration";

import {
  aiTrainGetList,
  aiTrainDelete,
  aiTrainSave,
} from "@/api/basicConfiguration";

// 默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
};
export default {
  name: "productNameTraining",
  components: {
    Treeselect,
  },
  computed: {
    ...mapGetters(["hasPermission", "getPermissionId"]),
  },
  data() {
    return {
      compId: null,
      userId: null,
      roleId: null,
      shopIds: [], // 权限管理中允许用户使用的店铺，高级角色看所有店铺

      shop_id: null, // 用户选中门店
      isKeepDayActive: true,
      isKeepMonthActive: true,

      // 添加商品
      item_id: null,
      productOptions: [],
      itemMap: null,

      // 导入文件
      fileList: [], // 用于存储已选择的文件列表
      uploadAction: "", // 后端接收文件的接口
      canshu: {},
      qrcode: "",
      // 列表组件参数
      basicListconfig: {
        loading: false,
        operationWidth: 180,
        search: [
          {
            label: "商品分类",
            type: "treeselect",
            options: [],
            key: "class_id",
          },
          {
            label: "状态",
            key: "alias_status",
            type: "select",
            options: [
              {
                label: "已训练",
                value: 1,
              },
              {
                label: "未训练",
                value: -1,
              },
            ],
          },
          {
            label: "商品编码/名称",
            type: "input",
            key: "keywords",
          },
        ],
        buttonList: [],
        data: [],
        column: [
          {
            label: "商品分类",
            prop: "class_name",
            width: 30,
          },
          {
            label: "商品编号",
            prop: "item_number",
            width: 50,
          },
          {
            label: "商品名称",
            prop: "name",
            width: 80,
          },
          {
            label: "销量",
            sortable: true,
            prop: "sales_num",
            width: 30,
          },
          {
            label: "别名",
            prop: "alias",
            width: 180,
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      addrules: {},

      dialogVisible: false,
      title: "",

      actionUrl: "",
      headers: {},
      defaultParametersVisible: false,
      addform: {
        item_id: "",
        name: "",
        comp_id: "",
        alias: "",
        item_id: "",
      },
      apiBase: process.env.VUE_APP_BASE_API || 'https://erp.zuizhenshi.cn',
    };
  },
  created() {
    this.compId = this.$store.getters.userInfo.compId;
    this.userId = this.$store.getters.userInfo.userId;
    this.roleId = this.$store.getters.userInfo.roleId;
    this.shopId = this.$store.getters.userInfo.shopId;

    if (this.shopId) {
      this.basicListconfig.searchParameters.shop_id = this.shopId;
    }

    this.headers = {
      "x-token": getSession(),
    };
    this.canshu = {
      comp_id: this.compId,
    };

    console.log(
      "%c [  ]-243",
      "font-size:13px; background:pink; color:#bf2c9f;",
      process.env.NODE_ENV
    );
    switch (process.env.NODE_ENV) {
      // 线上同源
      case "prod":
        this.uploadAction = "http://47.100.124.64";
        break;
      // 开发同源
      case "development":
        this.uploadAction = this.apiBase;
        break;
      // 开发跨域
      case "local":
        this.uploadAction = this.apiBase;
        break;
    }
    this.uploadAction = this.uploadAction + "/admin/ai_train/import";

    // 依据权限获取数据
    this.obtainPermissionDataSource(this.getPermissionId("商品-商品管理-查看"));

    this.getlist();
  },
  methods: {
    beforeUpload(file) {
      // 检查文件类型
      const isExcel =
        file.type === "application/vnd.ms-excel" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (!isExcel) {
        this.$message.error("只能上传Excel文件");
      }
      return isExcel;
    },
    // 文件上传成功的处理
    handleSuccess(response, file) {
      this.$message.success("文件上传成功");
      this.getlist();
    },
    // 文件选择改变时的处理
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    submit() {
      aiTrainSave(this.addform).then((res) => {
        if (res.code == 1) {
          this.$message.success("操作成功");
          this.getlist();
          this.close();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    close() {
      this.defaultParametersVisible = false;
    },
    edit(row) {
      this.addform = {
        item_number: row.item_number,
        item_id: row.item_id,
        name: row.name,
        comp_id: this.compId,
        alias: row.alias,
      };
      this.defaultParametersVisible = true;
    },
    clear(row) {
      this.$confirm("清空后数据将无法恢复，确定要执行吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        aiTrainDelete({ comp_id: this.compId, item_id: row.item_id }).then(
          (res) => {
            if (res.code == 1) {
              this.$message.success("操作成功");
              this.getlist();
            } else {
              this.$message.error(res.data.msg);
            }
          }
        );
      });
    },
    sortChange(data) {
      this.basicListconfig.searchParameters.page = 1;
      this.basicListconfig.searchParameters.order_column = data.prop;
      this.basicListconfig.searchParameters.order_up =
        data.order == "ascending" ? 1 : data.order == "descending" ? 0 : "";
      this.getlist();
    },
    // 获取数据源
    obtainPermissionDataSource(permissionId) {
      // 获取商品分类
      itemClassGetList().then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "class_id") {
              item.options = this.$findChildren(0, res.data);
            }
            return item;
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    // 导出文件
    exportExcel() {
      let headers = {
        "x-token": getSession(),
      };
      let downloadUrl = this.apiBase + "/admin/ai_train/export";
      let url =
        downloadUrl +
        "?comp_id=" +
        this.compId +
        "&keywords=" +
        this.basicListconfig.searchParameters.keywords
          ? this.basicListconfig.searchParameters.keywords
          : null +
            "&order_column=sales_num&order_up=" +
            this.basicListconfig.searchParameters.order_up
          ? this.basicListconfig.searchParameters.order_up
          : null;

      axios({
        method: "GET",
        url: url,
        responseType: "blob", // 重要，设置响应类型为blob
        withCredentials: true, // 如果需要携带 cookie
        headers: {
          "x-token": getSession(), // 添加自定义请求头
        },
      })
        .then((response) => {
          // 创建一个新的 Blob 对象，使用响应数据
          const blob = new Blob([response.data]);
          // 为 Blob 生成一个链接
          const downloadUrl = window.URL.createObjectURL(blob);
          // 创建一个临时的 <a> 标签用于下载
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", "品名训练-导出数据.xlsx"); // 设置下载文件名
          document.body.appendChild(link);
          link.click(); // 模拟点击进行下载
          document.body.removeChild(link); // 下载完成后移除元素
          window.URL.revokeObjectURL(downloadUrl); // 释放掉blob对象使用的内存
        })
        .catch((error) => {
          console.error("下载文件失败:", error);
        });
    },
    // 搜索事件
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          if (Array.isArray(data[key])) {
            if (data[key].length == 0) {
              delete this.basicListconfig.searchParameters.begin_time;
              delete this.basicListconfig.searchParameters.end_time;
            } else {
              this.basicListconfig.searchParameters.begin_time = data[key][0];
              this.basicListconfig.searchParameters.end_time = data[key][1];
            }
          }
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;

        // 默认查本店
        // if (!this.basicListconfig.searchParameters.shop_id) {
        //   this.$message.error("请先选中门店！");
        //   return;
        // }

        this.getlist();
      }
    },

    // 获取列表内容
    getlist() {
      this.basicListconfig.loading = true;
      this.basicListconfig.searchParameters["comp_id"] = this.compId;
      aiTrainGetList(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.data = res.data;
          this.basicListconfig.total = Number(res.count);
        } else if (res.code == 0) {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style>
.warn,
.dangerous,
.safe {
  margin-right: 5px; /* 右边距 */
}

/* 小于或等于10天时的警告样式 */
.warn {
  color: red; /* 红色文字 */
}

/* 负数时的警告样式 */
.dangerous {
  color: red; /* 红色文字 */
  font-weight: bold; /* 字体加粗 */
}

.safe {
  color: green;
}
</style>



// WEBPACK FOOTER //
// src/views/productNameTraining/index.vue